import { render, staticRenderFns } from "./PuzzleFencesCreate.vue?vue&type=template&id=7690b310&"
import script from "./PuzzleFencesCreate.vue?vue&type=script&lang=js&"
export * from "./PuzzleFencesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports